import React from "react";
import {
    Modal,
    Form,
    Input,
    Button,
    Select,
    Checkbox,
    Spin,
    message,
} from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { post, get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { realyNameRegThai } from "$ACTIONS/reg";
import { getMaskHandler } from "$ACTIONS/helper";
import { GETBankDetails, GetMemberBanks } from "$DATA/wallet";
import ImageWithFallback from "@/ImageWithFallback/imgLocal";
import { bankCodeWriting } from "$ACTIONS/util";
import { CaretDownOutlined, CloseCircleFilled } from "@ant-design/icons";
import PhoneVerify from "@/Verification/PhoneVerify";

const { Item } = Form;
const { Option } = Select;
const _bankNumber = /^[0-9]{10,19}$/;

class AddBankCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            BankList: [],
            isLoading: false,
            submitButtonDisabled: true,
            isSetDefault: false,
            selectValue: "",
            alreadyBindBanks: props.alreadyBindBanks,
            searchValue: "",
            open: false,
            isFocus: false,
            phoneattemptRemaining: 5,
            phoneVisible: false,
        };
    }
    componentDidMount() {
        this.getBankList();
        !this.state.alreadyBindBanks && this.getMemberBanksList();
    }
    componentDidUpdate(prevProps, prevState) {}
    getBankList = () => {
        this.setState({ isLoading: true });
        const transactionType =
            this.props.selectedType === "D" ? "Deposit" : "Withdrawal";
        GETBankDetails(transactionType, "LB", "DEFAULT", (res) => {
            this.setState({ isLoading: false });
            if (res && res.result) {
                let filterDupBank = res.result.banks.filter((obj, pos, arr) => {
                    return (
                        arr.map((mapObj) => mapObj.name).indexOf(obj.name) ==
                        pos
                    );
                });
                this.setState({
                    BankList: filterDupBank,
                });
            }
        });
    };
    getMemberBanksList = () => {
        this.setState({ isLoading: true });
        const { selectedType } = this.props;
        const type = selectedType === "D" ? "Deposit" : "Withdrawal";
        GetMemberBanks((res) => {
            this.setState({ isLoading: false });
            if (res?.isSuccess && res?.result?.length) {
                this.setState({
                    alreadyBindBanks: res.result.sort((a, b) => {
                        return b.isDefault - a.isDefault;
                    }),
                });
            } else {
                this.setState({ alreadyBindBanks: [] });
            }
        }, type);
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (!values) {
                    return;
                }
                
                // isSingleDeposit 為 false 且 為添加存款銀行卡則 不需要OTP認證
                if (this.props.selectedType === "D" && !this.props.memberInfo?.isSingleDeposit) {
                    this.addBankCardAction();
                    return;
                }

                this.setState({ phoneVisible: true });
            }
        });
    };
    addBankCardAction = () => {
        const values = this.props.form.getFieldsValue();
        this.setState({ isLoading: true, phoneVisible: false });

        post(ApiPort.POSTRememberBanks, {
            accountHolderName: this.props.memberInfo.firstName,
            accountNumber: values.cardnumber,
            bankName: values.bankname,
            type: this.props.selectedType, //W 或 D，當member isSingleDeposit = true時，無論用D或W，都可以同時新增在D跟W type內
            isDefault: this.state.alreadyBindBanks?.length
                ? this.state.isSetDefault
                : true,
        })
            .then((res) => {
                this.setState({ isLoading: false });
                console.log("response data", res);
                
                if (res?.isSuccess) {
                    global.showResultModal("เพิ่มบัญชีสำเร็จ", true); //保存银行信息成功！
                    this.props.getMemberBanksList(true);
                    this.onclosed();
                }
            })
            .catch((error) => {
                console.log("error", error);
                this.setState({ isLoading: false });
            });
    };
    VerifyCategory = (otpVisible, emailVisible, phoneVisible) => {
        this.setState({
            phoneVisible: phoneVisible,
        });
    };
    handleFormChange = () => {
        let status =
            Object.entries(this.props.form.getFieldsError()).every(
                (v) => v[1] === undefined
            ) &&
            Object.entries(this.props.form.getFieldsValue()).every(
                (v) => v[1] !== undefined
            ) &&
            this.props.form.getFieldValue("bankname") &&
            this.state.selectValue;
        this.setState({ submitButtonDisabled: !status });
        console.log(
            "getFieldValue2",
            this.props.form.getFieldsValue(),
            this.state.selectValue
        );
    };
    isSetDefault = () => {
        this.setState((prevState) => ({
            isSetDefault: !prevState.isSetDefault,
        }));
    };
    changeBankName = (value, option) => {
        this.props.form.setFieldsValue({ bankname: value });
        this.setState(
            {
                selectValue: value,
                open: false,
            },
            () => {
                this.handleFormChange();
            }
        );
        console.log("getFieldValue1", this.props.form.getFieldsValue());
    };
    onclosed = () => {
        this.setState({
            selectValue: "",
            open: false,
            submitButtonDisabled: true,
            isSetDefault: false,
        });
        this.props.closeModal();
        this.props.form.resetFields();
        console.log("onCloseAction");
    };
    handleSearchChange = (v) => {
        this.setState({ searchValue: v });
    };
    renderDropdown = (menu) => (
        <>
            <div className="placeholder-container">กรุณาเลือกธนาคาร</div>
            <div className="search-container">
                <img
                    className="search-icon"
                    src={"/th/img/icon/search.svg"}
                    ale="search"
                />
                <Input
                    className="search-input"
                    value={this.state.searchValue}
                    onChange={(e) => {
                        this.handleSearchChange(e.target.value);
                    }}
                    onFocus={() => {
                        this.setState({ isFocus: true });
                    }}
                    onBlur={() => {
                        this.setState({ isFocus: false });
                    }}
                    size="large"
                    autoComplete="off"
                    placeholder="ค้นหา" /* 搜索 */
                />
                {this.state.searchValue && (
                    <div
                        onClick={() => {
                            this.handleSearchChange("");
                        }}
                        className="search-clear"
                    >
                        <CloseCircleFilled />
                    </div>
                )}
            </div>
            {menu}
        </>
    );
    render() {
        const { getFieldDecorator } = this.props.form;
        const { BankList, isSetDefault, selectValue, searchValue } = this.state;

        return (
        <>
            {/* 添加 銀行卡 驗證 */}
            {/* Refer TO 'pages\referrer-activity.js' 'PhoneVerify' Usage */}
            {this.state.phoneVisible && (
                <PhoneVerify
                    GetThroughoutVerification={() => {
                        global.GetThroughoutVerification();
                    }}
                    memberInfo={this.props.memberInfo}
                    visible={this.state.phoneVisible}
                    closeModal={() =>
                        this.setState({ phoneVisible: false })
                    }
                    addBankCardAction={this.addBankCardAction}
                    changeVerify={this.VerifyCategory}
                    phone={
                        this.props.memberInfo.isVerifiedPhone &&
                        this.props.memberInfo.isVerifiedPhone[0]
                    }
                    otpParam={`bank-otp`}
                    kindOfVerifications={"AddWithdrawalBankCardVerification"}
                    phoneattemptRemaining={this.state.phoneattemptRemaining}
                    setPhoneAttemptRemaining={(v) =>
                        this.setState({ phoneattemptRemaining: v })
                    }
                    modalTitle={`ยืนยันข้อมูลเบอร์โทรศัพท์`} //手机验证
                    times={"5"}
                    isAllowChange={false}
                />
            )}

            <Modal
                title="เพิ่มบัญชี" //添加银行账户
                visible={this.props.visible}
                onCancel={this.onclosed}
                width={400}
                footer={null}
                maskClosable={false}
                className="modal-pubilc addBankModal"
            >
                <Spin spinning={this.state.isLoading}>
                    {/* <div style={{ textAlign : "center", fontSize : "20px", fontWeight : "800", padding:"15px" }}>添加银行卡</div> */}
                    <Form
                        className="verification-form-wrap"
                        {...formItemLayout}
                        onSubmit={this.handleSubmit}
                        onChange={this.handleFormChange}
                    >
                        <div className="TextLightYellow">
                            กรุณาเพิ่มบัญชีธนาคารก่อนการฝากเงิน
                            หากเพิ่มแล้วจะไม่สามารถ แก้ไขข้อมูลได้
                            โปรดตรวจสอบให้แน่ใจว่าข้อมูลถูกต้อง เพื่อป้องกัน
                            ธุรกรรมถูกยกเลิกหรือยอดเงินสูญหาย
                        </div>
                        <Item
                            label={
                                <>
                                    <div>ชื่อ นามสกุล</div>
                                    <div className="fail-color">
                                        กรุณาเว้นวรรคระหว่างชื่อและนามสกุล
                                    </div>
                                </>
                            }
                        >
                            {/* 账户持有者全名 */}
                            {getFieldDecorator("username", {
                                initialValue: getMaskHandler(
                                    "RealName",
                                    this.props.memberInfo.firstName
                                ),
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "กรอกชื่อ นามสกุลโดยไม่ต้องกรอกคำนำหน้า",
                                    },
                                    // {
                                    //     validator: (rule, value, callback) => {
                                    //         alert(value);
                                    //         if (
                                    //             value &&
                                    //             !realyNameRegThai.test(value)
                                    //         ) {
                                    //             callback("格式不正确");
                                    //         }
                                    //         callback();
                                    //     },
                                    // },
                                ],
                            })(
                                <Input
                                    size="large"
                                    autoComplete="off"
                                    disabled
                                    placeholder="กรอกชื่อ นามสกุลโดยไม่ต้องกรอกคำนำหน้า" //请輸入您的名字和姓氏，不帶前綴。
                                />
                            )}
                        </Item>
                        <Item
                            label="ชื่อธนาคาร" //银行名称
                            className={`Item-bankName`}
                        >
                            {getFieldDecorator("bankname", {
                                initialValue: selectValue,
                                // rules: [
                                //     {
                                //         required: true,
                                //         message: "กรุณาเลือกธนาคาร", //请选择银行！
                                //     },
                                // ],
                            })(
                                <div>
                                    <Select
                                        placeholder={"กรุณาเลือกธนาคาร"} //选择银行
                                        size="large"
                                        loading={
                                            !BankList.length ? true : false
                                        }
                                        value={
                                            !this.state.open && selectValue
                                                ? selectValue
                                                : []
                                        }
                                        onChange={this.changeBankName}
                                        open={this.state.open}
                                        onDropdownVisibleChange={() => {
                                            this.setState({
                                                open: true,
                                            });
                                        }}
                                        // showArrow={true}
                                        suffixIcon={<CaretDownOutlined />}
                                        optionFilterProp="children"
                                        notFoundContent={
                                            <div className="notfind">
                                                <img
                                                    src="/th/img/icon/emptyIcon.svg"
                                                    alt="notfind"
                                                />
                                                <p>
                                                    ไม่พบข้อมูล
                                                    {/* 暂无数据 */}
                                                </p>
                                            </div>
                                        }
                                        className="bankNameSelect"
                                        dropdownClassName={`bankNameSelectDropdown${
                                            this.state.isFocus ? " focus" : ""
                                        }`}
                                        getPopupContainer={(triggerNode) =>
                                            triggerNode.parentNode
                                        }
                                        dropdownRender={this.renderDropdown}
                                    >
                                        {BankList.filter((item) =>
                                            item.name.includes(searchValue)
                                        ).map((val, index) => {
                                            return (
                                                <Option
                                                    key={index}
                                                    value={val.name}
                                                    className={`${
                                                        selectValue === val.name
                                                            ? "selected"
                                                            : ""
                                                    }`}
                                                >
                                                    <div className="bank-image">
                                                        <ImageWithFallback
                                                            src={`/th/img/bank/${bankCodeWriting(
                                                                val.englishName
                                                            )}.svg`}
                                                            width={18}
                                                            height={18}
                                                            alt={
                                                                val.englishName
                                                            }
                                                            fallbackSrc="/th/img/bank/generic.svg"
                                                        />
                                                    </div>
                                                    <p className="name">
                                                        {val.name}
                                                    </p>
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                            )}
                        </Item>
                        <Item label="บัญชีธนาคาร">
                            {/* 银行账户号码 */}
                            {getFieldDecorator("cardnumber", {
                                rules: [
                                    {
                                        required: true,
                                        message: "โปรดกรอกหมายเลขบัญชีธนาคาร",
                                    }, //请输入您的账户号码
                                    {
                                        validator: (rule, value, callback) => {
                                            if (
                                                value &&
                                                !_bankNumber.test(value)
                                            ) {
                                                callback(
                                                    "หมายเลขบัญชีต้องอยู่ระหว่าง 10~19 หลัก"
                                                ); //銀行帳戶需有10~19碼
                                            }
                                            callback();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    size="large"
                                    maxLength={19}
                                    autoComplete="off"
                                    placeholder="เลขที่บัญชีจะต้องมี 10​~19 หลัก"
                                />
                            )}
                        </Item>
                        <Item
                            label=""
                            className="small-form-item checkbox-button-container"
                            style={{ textAlign: "left" }}
                        >
                            <Checkbox
                                checked={isSetDefault}
                                onChange={this.isSetDefault}
                            >
                                ตั้งเป็นค่าเริ่มต้น
                                {/* 设定为首选银行账户 */}
                            </Checkbox>
                        </Item>
                        {/* <p className="bottom-sign-2">开户名必须和账号持有者姓名相同，如需修改请联系<Button className="inline" type="link" onClick={global.PopUpLiveChat}>在线客服</Button>。</p> */}
                        <Item {...tailFormItemLayout}>
                            <div className="btn-wrap">
                                <Button
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    disabled={this.state.submitButtonDisabled}
                                >
                                    ยืนยัน
                                    {/* 保存 */}
                                </Button>
                            </div>
                        </Item>
                    </Form>
                </Spin>
            </Modal>
        </>
        );
    }
}

export default Form.create({ name: "AddBankCard" })(AddBankCard);
